export const environment = {
  production: true,
  urlApi: 'https://atendimento360-backend.govbr.com.br/portalservicosapi/api',
  urlSigaSolicitante: 'https://csiga.govbr.com.br/loginusuario.php?authws=',
  gAnalyticsPropId: 'G-C8Q8WLVZFF'
};
